<script>
import Checkbox from '@/packages/ui/components/Checkbox/Checkbox.vue';
import Divider from '@/packages/ui/components/Divider/Divider.vue';
import Icon from '@/packages/ui/components/Icon/Icon.vue';
import IconLegacy from '@/components/Icon.vue';
import Tooltip from '@/packages/ui/components/Tooltip/Tooltip.vue';

export default {
  name: 'TableAttributes',
  components: {
    Checkbox,
    Divider,
    Icon,
    IconLegacy,
    Tooltip,
  },
  props: {
    attributes: {
      type: Array,
      default: () => [], /* { name: name, uuid: uuid } */
    },
  },
  data() {
    return {
      isOpened: false,
      selected: [],
      selectedAll: false,
    };
  },
  computed: {
    isEmpty() {
      return this.attributes?.length === 0;
    },
    tooltipIconColor() {
      return this.isEmpty ? 'var(--track-color-bluegray-40)' : 'var(--track-color-bluegray-80)';
    },
    tooltipPosition() {
      return this.isEmpty ? 'middle left' : 'top left';
    },
    tooltipText() {
      return this.isEmpty ? this.$t('interactions.tooltip.no_metadata_columns') : this.$t('distribution.tooltip.show_columns');
    },
  },
  watch: {
    selected() {
      this.$emit('change', this.selected);
    },
    selectedAll() {
      this.selected = (this.selectedAll)
        ? [...this.attributes]
        : [];
    },
  },
  methods: {
    handleClickOutside() {
      this.isOpened = false;
    },
    handleToggleAttributes() {
      if (this.isEmpty === false) {
        this.isOpened = !this.isOpened;
      }
    },
  },
};
</script>

<template>
  <div
    v-click-out="handleClickOutside"
    class="cxm-TableAttributes"
  >
    <Tooltip
      :text="tooltipText"
      :position="tooltipPosition"
      width="120px"
    >
      <IconLegacy
        :color="tooltipIconColor"
        :icon-click="handleToggleAttributes"
      >
        <Icon
          name="TableEdit"
          size="22"
          color="var(--track-color-bluegray-80)"
          style="pointer-events: none;"
        />
      </IconLegacy>
    </Tooltip>

    <div
      v-show="isOpened"
      class="cxm-TableAttributes-Menu"
    >
      <div class="cxm-TableAttributes-MenuHeader">
        <Checkbox
          v-model="selectedAll"
          :label="$t('general.filter.show_all')"
        />
      </div>
      <Divider />
      <div class="cxm-TableAttributes-MenuContent">
        <div
          v-for="attribute in attributes"
          :key="attribute.uuid"
        >
          <Checkbox
            v-model="selected"
            :label="attribute.name"
            :value="attribute"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cxm-TableAttributes {
  position: relative;
}

.cxm-TableAttributes-Menu {
  background-color: var(--track-color-white);
  border-radius: var(--track-border-radius-md);
  box-shadow: 2px 2px 10px #ccc;
  min-width: 250px;
  overflow-y: auto;
  padding: var(--track-spacing-md);
  position: absolute;
  right: 0;
  z-index: 100;
}

.cxm-TableAttributes-MenuContent {
  display: flex;
  flex-direction: column;
  gap: var(--track-spacing-sm);
  max-height: 225px;
  overflow-y: auto;
}
</style>
